import { MediaMatcher } from '@angular/cdk/layout';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import {
  IFilter,
  IListado,
  IQueryParam,
  IRegistro,
  IUsuario,
} from 'modelos/src';
import { DialogService } from '../../../auxiliares/dialog/dialog.service';
import { ListadosService } from '../../../auxiliares/servicios/listados.service';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { AuthService } from '../../login/auth.service';
import {
  IFiltroTabla,
  IRegExpSearch,
} from 'src/app/auxiliares/filtro-tabla/filtro-tabla/filtro-tabla.component';
import { RegistrosService } from '../registros.service';

declare type mainType = IRegistro;

@Component({
  selector: 'app-listado-registros',
  templateUrl: './listado-registros.component.html',
  styleUrls: ['./listado-registros.component.scss'],
  standalone: false,
})
export class ListarRegistrosComponent implements OnInit, OnDestroy {
  private changeDetectorRef = inject(ChangeDetectorRef);
  private media = inject(MediaMatcher);
  private dialogService = inject(DialogService);
  private listadosService = inject(ListadosService);
  private service = inject(RegistrosService);
  matDialog = inject(MatDialog);
  helper = inject(HelperService);
  authService = inject(AuthService);

  public search: IRegExpSearch = {
    fields: [
      'app',
      'datosPersonales.nombre',
      'datosPersonales.dni',
      'datosPersonales.telefono',
    ],
  };

  public clientes: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    selectLabel: 'nombre',
    selectValue: '_id',
    tipo: 'select',
  };

  // public usuarioActual?: IUsuario;

  public loading = true;
  public columnas = [
    'fechaCreacion',
    'codigo',
    'nombre',
    'dni',
    'telefono',
    'email',
    'clienteActual',
    'modoRegistro',
    'acciones',
  ];
  public nombreColumnas = [
    'Fecha de creación',
    'Código',
    'Nombre',
    'DNI',
    'Teléfono',
    'Email',
    'Cliente Actual',
    'Modo de Registro',
    'Acciones',
  ];
  public saveColumnas = 'tabla-registros-pendientes';
  public dataSource = new MatTableDataSource<mainType>([]);
  private datos: mainType[] = [];
  public usuarioActual?: IUsuario;
  // FILTRO BUSQUEDA Y PAGINACION
  public totalCount = 0;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private initialFilters: IFilter<any> = {
    'envioCodigo.codigo': { $exists: true, $ne: '' },
  };
  private populate = {
    path: 'cliente',
    select: 'nombre',
  };
  public queryParams: IQueryParam = {
    page: 0,
    limit: +this.helper.pageSize,
    populate: JSON.stringify(this.populate),
    filter: JSON.stringify(this.initialFilters),
    sort: '-fechaCreacion',
  };

  // Listado Continuo
  private datos$?: Subscription;
  private clientes$?: Subscription;
  // Mobile query
  public mobileQuery: MediaQueryList;
  //

  constructor() {
    this.mobileQuery = this.media.matchMedia('(max-width: 599px)');
    this.mobileQuery.addEventListener('change', () =>
      this.changeDetectorRef.detectChanges(),
    );
  }

  // ################################################################################
  // ################################# TABLA 1 ######################################
  // ################################################################################
  public pageEvent(event: PageEvent): void {
    this.helper.pageEvent(event);
    this.queryParams.page = event.pageIndex;
    this.queryParams.limit = event.pageSize;
    this.actualizar();
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public async cambioFiltro(filters: IFilter<any>) {
    this.loading = true;
    this.queryParams = {
      page: 0,
      limit: this.queryParams.limit,
      sort: this.queryParams.sort,
      populate: this.queryParams.populate,
      select: this.queryParams.select,
      filter: JSON.stringify(filters),
    };
    await this.actualizar();
    this.loading = false;
  }
  public sortChange(event: Sort): void {
    this.queryParams.sort =
      event.direction === 'asc' ? event.active : `-${event.active}`;
    this.actualizar();
  }

  // ACCIONES

  public async eliminar(dato: mainType): Promise<void> {
    const confirm = await this.dialogService.confirm(
      'Confirme la acción',
      `¿Eliminar el registro ${dato._id}?`,
    );
    if (confirm) {
      try {
        this.loading = true;
        await this.service.eliminar(dato._id!).pipe(take(1)).toPromise();
        this.helper.notifSuccess('Eliminación correcta');
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.helper.notifError(error);
        this.loading = false;
      }
    }
  }

  // Listar

  public async actualizar(): Promise<void> {
    this.loading = true;
    await this.listar();
    this.loading = false;
  }

  private async listar(): Promise<void> {
    this.datos$?.unsubscribe();
    this.datos$ = this.listadosService
      .subscribe<IListado<IRegistro>>('registros', this.queryParams)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.dataSource.data = data.datos;
        console.debug(
          new Date().toLocaleString(),
          `listado de registros`,
          data,
        );
      });
    await this.listadosService.getLastValue('registros', this.queryParams);
  }

  // private async listarClientes(): Promise<void> {
  //   const query: IQueryParam = {
  //     sort: 'nombre',
  //     select: 'nombre',
  //   };

  //   this.clientes$?.unsubscribe();
  //   this.clientes$ = this.listadosService
  //     .subscribe<IListado<ICliente>>('clientes', query)
  //     .subscribe((data) => {
  //       this.clientes.elementos = data.datos;
  //       console.debug(new Date().toLocaleString(), `listado de clientes`, data);
  //     });
  //   await this.listadosService.getLastValue('clientes', query);
  // }

  async ngOnInit(): Promise<void> {
    this.usuarioActual = this.authService.getUsuario();
    await Promise.all([this.actualizar()]);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', () =>
      this.changeDetectorRef.detectChanges(),
    );
    this.datos$?.unsubscribe();
  }
}
